import "./page-high-resolution-satellite-imagery.scss";
import "../../js/core";
import { SwiperInit } from "../../components/site-elements/other-blocks/swiper-tabs/swiper-tabs";
import "../../components/site-elements/other-blocks/collapse-tabs/collapse-tabs";

SwiperInit("swiper-1");

function changeImgOnSlider() {
  var handleMutation = function (mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        let activeElement = $(
          ".slider-features .owl-item.active:first .card"
        ).data("active-img-name");
        $("#" + activeElement).addClass("active");
        $("#" + activeElement)
          .siblings(".img-item")
          .removeClass("active");

        let showedSlide = $(".slider-features .owl-item.active");
        let slideContent = showedSlide.find(".content");
        let slideCard = showedSlide.find(".card");
        let contentHeight = slideContent.innerHeight();

        console.log(contentHeight);
        if ($(window).width() <= 991 && $(window).width() >= 768) {
          if (contentHeight > 260) {
            slideCard.addClass("short");
          }
        } else if ($(window).width() <= 767) {
          if (contentHeight > 131) {
            slideCard.addClass("short");
          }
        }
      }
    }
  };
  var observer = new MutationObserver(handleMutation);
  observer.observe(document.querySelector(".slider-features .owl-stage"), {
    attributes: true,
    subtree: true,
  });
}

$(function () {
  import(
    /* webpackChunkName: "chunk.owl-carousel" */ "owl.carousel/src/js/owl.carousel"
  ).then(() => {
    import(
      /* webpackChunkName: "chunk.owl-carousel-navigation" */ "owl.carousel/src/js/owl.navigation"
    ).then(() => {
      jQuery(".slider-features").owlCarousel({
        responsive: {
          0: {
            items: 1,
            dots: false,
          },
          992: {
            items: 3,
            dots: true,
          },
        },
        loop: true,
        nav: true,
        dotsEach: true,
        slideBy: 1,
        margin: 20,
        smartSpeed: 200,
      });

      changeImgOnSlider();

      $(".slider-features .owl-item .btn-link").on("click", function () {
        $(this).parent(".card").toggleClass("open");
      });

      $(".slider-features").on("changed.owl.carousel", function (event) {
        $(".slider-features .owl-item .card").removeClass("open");
      });

      $(".owl-carousel").each(function (index) {
        $(this)
          .find(".owl-nav, .owl-dots")
          .wrapAll("<div class='owl-controls'></div>");
      });
    });
  });
});
